import ThumbnailSelector from "./components/ThumbnailSelector";

export default () => <ThumbnailSelector />;
